import { ModalProvider } from 'react-modal-hook';
import { ReactNode } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';

import { Locale } from '__generated__/graphql';

import { FooterNav, NavBar, Wrapper } from '../Common/Layout';
import { defaultSecondary } from '../../theme/variables';
import { guessLocale, isValidLocale } from '../../common/helpers';
import { useBrandColor } from '../../common/Common/ThemeProvider';
import CookieConsentBar from '../../common/Common/CookieConsentBar';
import LocaleProvider from '../../common/LocaleProvider';
import useAtletaEmbed from '../../common/useAtletaEmbed';

export const WebsiteLayout = ({
  children,
}: {
  children?: ReactNode;
}) => {
  useBrandColor(defaultSecondary);

  const match = useRouteMatch<{ locale?: string; path?: string; }>('/:locale?/:path?');
  const locale = isValidLocale(match.params.locale) ? match.params.locale : guessLocale(Locale.en);
  const history = useHistory();
  const location = useLocation();

  useAtletaEmbed({
    disableEmbed: true,
    disableTracking: true,
  });

  const isHomePage = !match.params.path;

  const handleChangeLocale = (locale: Locale) => {
    const { pathname, search, hash } = location;

    const segments = pathname.split('/');

    // Path starts with a slash.
    if (isValidLocale(segments[1])) {
      if (segments.length > 1) {
        segments[1] = locale;
      }

      const newPath = segments.join('/');

      history.replace(newPath + search + hash);
    }
  };

  return (
    <LocaleProvider locale={locale}>
      <ModalProvider>
        <NavBar
          onChangeLocale={handleChangeLocale}
          showFullLogo
          showOrganiserButton
          isHomePage={isHomePage}
        />

        <Wrapper>
          {children}

          <FooterNav onChangeLocale={handleChangeLocale} />
        </Wrapper>

        <CookieConsentBar />
      </ModalProvider>
    </LocaleProvider>
  );
};

export default undefined;
